export default {
  namespaced: true,
  actions: {
    getByPIN({ dispatch, rootGetters }, PIN) {
      return dispatch('Acacia/Utils/Resources/GET', {
        service: 'pin',
        model: 'PIN',
        url: `/${PIN}`,
        baseURL: rootGetters['Acacia/Models/PIN/DefaultBaseURL'],
        sysIgnoreAuthorizarion: true,
      }, { root: true })
        .then((pin) => {
          dispatch('Acacia/Models/PIN/Set', pin, { root: true });
        });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/setting_provider/pin/index.js